import type { FaireProductEntity } from "../../entity_types/product";

export const p_swtmjx2mnc: FaireProductEntity = {
  token: "p_swtmjx2mnc",
  type: "product",
  name: "Peony Scallop Knit Women’s Cardigan (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/06a025372c8f287a1bea0f0730886603c9de08edaf9d4c11b6fd6328222a7bf9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8816a26f611b5d1dbfbfdc4624cd854d0b0e7c215a09ef402332b39bc4f6165.png",
    "https://cdn.faire.com/fastly/d2f1b3c97ac874788aaf751ae9aa8730260e922cfcf26a1be438b9311da993a1.png",
  ],
  priceDollars: 44,
  description:
    "A graceful spring layer, the Peony Scallop Cardigan is crafted from certified organic cotton in a soft natural hue. Designed with a classic round neckline and button-front closure, it features a delicate scalloped trim along the front opening for a sweet, vintage-inspired finish.\n\nPink peony-like floral embroidery blooms across the front, adding a romantic garden touch to this timeless knit. Soft, breathable, and thoughtfully made, it’s a beautiful piece for everyday layering and special moments alike.\n\nCreated to coordinate beautifully with matching Mommy & Me baby styles, this cardigan blends comfort, craftsmanship, and sustainability. Designed in the USA and ethically produced in India, it’s made to be worn, loved, and cherished.",
  tags: [],
  msrpDollars: 88,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:31.518Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
